/**
 * doofinder-cart.js
 * Ergänzt Artikel, die über den Doofinder-Layer in den Warenkorb gelegt werden,
 * um die Line-Item-Property "Pfand" (Anzeigewert wie im Produktformular)
 * und aktualisiert danach Cart-Icon und Cart Drawer.
 *
 * Doofinder ruft /cart/add.js selbst auf – dieses Script legt keinen Basisartikel an.
 */
(function () {
  const PROPERTY_NAME = 'Pfand';
  const POLL_INTERVAL = 150; // ms
  const POLL_TRIES    = 14;  // max. ca. 2 s warten, bis Doofinders Add im Cart sichtbar ist

  const routes = {
    cart:   theme.routes.cart,                 // "/cart"
    change: `${theme.routes.cart}/change.js`
  };

  const jsonHeaders = {
    'Content-Type': 'application/json',
    Accept: 'application/json',
    'X-Requested-With': 'XMLHttpRequest'
  };

  /** "0.15" | {amount:"0.15"} | 20 -> Number */
  function toNumber(value) {
    if (value == null) return 0;
    if (typeof value === 'object') value = value.amount;
    const n = parseFloat(String(value).replace(',', '.'));
    return Number.isFinite(n) ? n : 0;
  }

  /** Flaschenanzahl × Flaschenpfand + Kastenpfand */
  function calcDeposit(item) {
    const bottles = toNumber(item.custom_flaschenanzahl);
    const bottle  = toNumber(item.custom_einzelner_flaschenpfandwert);
    const crate   = toNumber(item.custom_einzelner_kastenpfandwert);
    return Math.round((bottles * bottle + crate) * 100) / 100;
  }

  /** 4.5 -> "4,50 €" (identisch zum Feebee-Format) */
  function formatEuro(amount) {
    return amount.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + ' €';
  }

  function getDrawer() {
    return document.querySelector('cart-drawer');
  }

  /** Gleiche Sections wie in product-form.js */
  function getSections() {
    let sections = 'cart-icon-bubble';
    const drawer = getDrawer();
    if (drawer) {
      sections += `,${drawer.closest('.shopify-section').id.replace('shopify-section-', '')}`;
    }
    return sections;
  }

  async function getCart() {
    const res = await fetch(`${routes.cart}.js`);
    if (!res.ok) throw new Error(`cart.js ${res.status}`);
    return res.json();
  }

  /** Menge einer Variante im Cart (alle Zeilen, mit und ohne Property) */
  function variantQty(cart, variantId) {
    return cart.items
      .filter((it) => it.variant_id === variantId)
      .reduce((sum, it) => sum + it.quantity, 0);
  }

  /** Wartet, bis Doofinders Add im Cart sichtbar ist; liefert den aktuellen Cart */
  async function waitForCartUpdate(variantId, targetQty) {
    let cart;
    for (let i = 0; i < POLL_TRIES; i++) {
      cart = await getCart();
      if (variantQty(cart, variantId) >= targetQty) return cart;
      await new Promise((r) => setTimeout(r, POLL_INTERVAL));
    }
    return cart; // Timeout: mit dem letzten Stand weitermachen
  }

  /** Nur Sections neu laden – aus der aktuellen Seite, wie CartDrawer.refresh() */
  async function fetchSections() {
    const res = await fetch(`${window.location.pathname}?sections=${getSections()}`);
    if (!res.ok) throw new Error(`sections ${res.status}`);
    return { sections: await res.json() };
  }

  function updateCartIcon(data) {
    const bubble = document.getElementById('cart-icon-bubble');
    if (bubble && data.sections && data.sections['cart-icon-bubble']) {
      bubble.innerHTML = data.sections['cart-icon-bubble'];
    }
  }

  async function handleAdd(event) {
    const item      = event.detail;
    const variantId = Number(item.item_id);
    const amount    = Number(item.amount) || 1;
    const deposit   = calcDeposit(item);

    // Ausgangsmenge merken (Doofinders Add läuft parallel an)
    const before    = await getCart();
    const targetQty = variantQty(before, variantId) + amount;

    // Warten, bis Doofinders Add im Cart angekommen ist
    const cart = await waitForCartUpdate(variantId, targetQty);
    const line = deposit > 0
      ? cart.items.find(
        (it) => it.variant_id === variantId && !(it.properties && it.properties[PROPERTY_NAME])
      )
      : null;

    let data;

    if (line) {
      // Pfand-Property direkt an Doofinders Zeile hängen – Shopify führt mit einer
      // bereits vorhandenen Zeile gleicher Variante + Property zusammen
      const res = await fetch(routes.change, {
        method: 'POST',
        headers: jsonHeaders,
        body: JSON.stringify({
          id: line.key,
          quantity: line.quantity,
          properties: { [PROPERTY_NAME]: formatEuro(deposit) },
          sections: getSections(),
          sections_url: window.location.pathname
        })
      });
      data = await res.json();
      if (!res.ok) throw new Error(data.description || data.message || res.status);
    } else {
      data = await fetchSections();
    }

    updateCartIcon(data);

    const drawer = getDrawer();
    if (drawer) {
      drawer.renderContents(data, true); // true = Drawer öffnen
    } else if (window.location.pathname === routes.cart) {
      document.querySelector('cart-items')?.refresh();
    }

    // Event für Apps/Tracking – Cart-Daten im Hintergrund holen, Drawer wartet nicht darauf
    getCart().then((cart) => {
      document.dispatchEvent(new CustomEvent('on:cart:add', {
        bubbles: true,
        detail: { cart, variantId }
      }));
    }).catch(() => {});
  }

  document.addEventListener('doofinder.cart.add', (event) => {
    handleAdd(event).catch((error) => {
      console.error('[doofinder-cart]', error); // eslint-disable-line
      getDrawer()?.refresh(true);
    });
  });
})();